import React from 'react';
import Map from './common/Map';

const position = {
  lat: 51.602075,
  lng: -0.635985,
};

const ContactMap = () => (
  <div className="development-map" style={{ height: 400 }}>
    <Map
      center={position}
      zoom={11}
      markers={[
        {
          position,
          icon: {
            url: '/icons/favicon-96x96.png',
            scaledSize: {
              width: 40,
              height: 40,
              equals: () => true,
            },
          },
          animation: 1,
          // place: {
          //   location: position,
          //   placeId: 'ChIJb0zr-L9ndkgR917OEMw-0J4',
          // },
        },
      ]}
    />
  </div>
);

export default ContactMap;
